export default "__VITE_ASSET__6b0dacf1__"